import _ from 'lodash';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import KeywordsCMSModel, { Keywords } from '@/visa-application/models/KeywordsCMSModel';
import { MINIO_BUCKET_ADDRESS } from '@/constants';

@Component
export default class Popup extends Vue {
  @Prop() public popupTitle: string;
  @Prop() public popupData: any;
  @Prop() public popupComponentName: string;
  @Prop() public popupDataLanguageAlert: string;
  @Prop({ default: true }) public showSecondComponent: boolean;
  @Prop({ default: true }) public hasConfirmAction: boolean;
  @Prop({ default: true }) public hasCancelAction: boolean;
  private keywords: Partial<Keywords> = {};
  public MINIO_BUCKET_ADDRESS = MINIO_BUCKET_ADDRESS;

  public close(): void {
    this.$emit('close-action');
  }

  public confirm(): void {
    this.$emit('confirm-action', this.popupData.out);
  }

  @Watch('$store.getters.keywords', { immediate: true })
  public onKeywordsChanged(keywords: Keywords): void {
    this.keywords = keywords;
  }
}
